/**
 * Upload Configuration
 *
 * Centralized configuration for video upload functionality.
 * All timing, retry, and timeout settings in one place.
 *
 * @module upload-config
 */

/**
 * Upload behavior configuration
 */
export const UPLOAD_CONFIG = {
  // Retry configuration
  MAX_RETRIES: 3,
  RETRY_DELAYS: [1000, 2000, 4000], // 1s, 2s, 4s exponential backoff
  RETRY_STATUS_CODES: [408, 429, 500, 502, 503, 504], // Retryable HTTP errors

  // Network recovery
  AUTO_RESUME_DELAY: 5000, // Wait 5s after reconnection before resuming

  // Timeout configuration
  BASE_TIMEOUT: 600000, // Base timeout: 10 minutes (600,000ms)
  TIMEOUT_PER_MB: 30000, // Add 30 seconds per MB of file size
  MAX_TIMEOUT: 1800000, // Maximum timeout: 30 minutes (1,800,000ms)
}

/**
 * Timing constants for various operations
 */
export const TIMING = {
  PROGRESS_POLL_INTERVAL: 100, // Poll for progress updates every 100ms
  CANCELLATION_CLEANUP_DELAY: 100, // Wait 100ms before cleaning up cancellation flag
  LONG_HIDDEN_THRESHOLD: 60000, // Warn if tab hidden for more than 1 minute
  COMPLETED_UPLOAD_DISPLAY: 3000, // Show completed upload for 3 seconds
}

/**
 * Network error detection patterns
 */
export const NETWORK_ERROR_PATTERNS = [
  'Network error',
  'ERR_NETWORK_CHANGED',
  'ERR_INTERNET_DISCONNECTED',
  'Failed to fetch',
]

/**
 * File size units for display
 */
export const FILE_SIZE = {
  KB: 1024,
  MB: 1024 * 1024,
  GB: 1024 * 1024 * 1024,
}

/**
 * Console log emoji prefixes for easy scanning
 */
export const LOG_EMOJI = {
  START: '🎬',
  SUCCESS: '✅',
  ERROR: '❌',
  WARNING: '⚠️',
  INFO: 'ℹ️',
  NETWORK: '📡',
  RETRY: '🔄',
  CANCEL: '🚫',
  PAUSE: '⏸️',
  RESUME: '▶️',
  TIMEOUT: '⏰',
  LOCK: '🔒',
  UNLOCK: '🔓',
  VISIBLE: '👁️',
  HIDDEN: '🙈',
  PROGRESS: '📊',
  ABORT: '🛑',
  QUEUE: '📋',
  DISPATCH: '📤',
  RECEIVE: '📥',
  ROCKET: '🚀',
}
